/* 4youFit: interacción de las secciones fy- (pasos, galería, variantes, carrusel y apariciones).
   Sin dependencias. El añadido al carrito lo hace <product-form> de Dawn (product-form.js). */
(function () {
  'use strict';

  if (window.fyScriptsListo) return;
  window.fyScriptsListo = true;

  const movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observador = null;

  function initPestanas(root) {
    const lista = root.querySelector('[data-fy-pestanas]');
    if (!lista) return;
    const pestanas = Array.from(lista.querySelectorAll('[role="tab"]'));

    function activar(pestana, enfocar) {
      pestanas.forEach(function (p) {
        const activa = p === pestana;
        p.setAttribute('aria-selected', String(activa));
        p.tabIndex = activa ? 0 : -1;
        const panel = document.getElementById(p.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-activo', activa);
      });
      if (enfocar) pestana.focus();
    }

    lista.addEventListener('click', function (e) {
      const p = e.target.closest('[role="tab"]');
      if (p) activar(p, false);
    });

    lista.addEventListener('keydown', function (e) {
      const i = pestanas.indexOf(document.activeElement);
      if (i < 0) return;
      const destinos = { ArrowDown: i + 1, ArrowRight: i + 1, ArrowUp: i - 1, ArrowLeft: i - 1, Home: 0, End: pestanas.length - 1 };
      if (!(e.key in destinos)) return;
      e.preventDefault();
      activar(pestanas[(destinos[e.key] + pestanas.length) % pestanas.length], true);
    });
  }

  function mostrarMedia(galeria, mediaId) {
    const slide = galeria.querySelector('[data-fy-slide="' + mediaId + '"]');
    if (!slide) return;
    galeria.querySelectorAll('[data-fy-slide]').forEach(function (s) {
      s.hidden = s !== slide;
    });
    galeria.querySelectorAll('[data-fy-mini]').forEach(function (m) {
      m.setAttribute('aria-current', String(m.dataset.fyMini === mediaId));
    });
  }

  function initGaleria(root) {
    const galeria = root.querySelector('[data-fy-galeria]');
    if (!galeria) return;
    galeria.addEventListener('click', function (e) {
      const mini = e.target.closest('[data-fy-mini]');
      if (mini) mostrarMedia(galeria, mini.dataset.fyMini);
    });
  }

  function initVariantes(root) {
    const zona = root.querySelector('[data-fy-compra]');
    const datos = zona && zona.querySelector('[data-fy-variantes]');
    if (!datos) return;

    const variantes = JSON.parse(datos.textContent);
    const input = zona.querySelector('form [name="id"]');
    const boton = zona.querySelector('[data-fy-boton]');
    const textoBoton = boton.querySelector('span');
    const precio = zona.querySelector('[data-fy-precio]');
    const antes = zona.querySelector('[data-fy-precio-antes]');
    const galeria = root.querySelector('[data-fy-galeria]');

    zona.addEventListener('change', function (e) {
      if (!e.target.matches('[data-fy-opcion]')) return;

      const elegidas = Array.from(zona.querySelectorAll('[data-fy-grupo]')).map(function (grupo) {
        const marcada = grupo.querySelector('input:checked');
        return marcada ? marcada.value : null;
      });
      const variante = variantes.find(function (v) {
        return v.options.every(function (valor, i) { return valor === elegidas[i]; });
      });

      if (!variante) {
        boton.disabled = true;
        textoBoton.textContent = boton.dataset.fyTextoNoDisponible;
        return;
      }

      input.value = variante.id;
      precio.textContent = variante.precio;
      if (antes) {
        antes.hidden = !variante.precio_antes;
        antes.querySelector('s').textContent = variante.precio_antes || '';
      }
      boton.disabled = !variante.available;
      textoBoton.textContent = variante.available ? boton.dataset.fyTextoComprar : boton.dataset.fyTextoAgotado;

      if (galeria && variante.media_id) mostrarMedia(galeria, String(variante.media_id));

      if (zona.dataset.fyActualizarUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  }

  // Carrusel de productos: flechas que avanzan de «página» en «página» sobre el scroll nativo
  function initCarrusel(root) {
    const carrusel = root.matches('[data-fy-carrusel]') ? root : root.querySelector('[data-fy-carrusel]');
    if (!carrusel) return;
    const pista = carrusel.querySelector('[data-fy-pista]');
    const anterior = carrusel.querySelector('[data-fy-prev]');
    const siguiente = carrusel.querySelector('[data-fy-next]');
    if (!pista || !anterior || !siguiente) return;

    function paso() {
      const item = pista.querySelector('li');
      if (!item) return pista.clientWidth;
      const hueco = parseFloat(getComputedStyle(pista).columnGap) || 0;
      const ancho = item.getBoundingClientRect().width + hueco;
      return Math.max(ancho, Math.floor((pista.clientWidth + hueco) / ancho) * ancho);
    }

    function actualizar() {
      const maximo = pista.scrollWidth - pista.clientWidth - 2;
      anterior.disabled = pista.scrollLeft <= 2;
      siguiente.disabled = pista.scrollLeft >= maximo;
      carrusel.classList.toggle('fy-carrusel--sin-desborde', maximo <= 0);
    }

    function mover(sentido) {
      pista.scrollBy({ left: sentido * paso(), behavior: movimientoReducido.matches ? 'auto' : 'smooth' });
    }

    anterior.addEventListener('click', function () { mover(-1); });
    siguiente.addEventListener('click', function () { mover(1); });
    pista.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }

  // Apariciones al hacer scroll (un único IntersectionObserver para toda la página)
  function initApariciones(root) {
    const elementos = root.querySelectorAll('.fy-reveal:not(.is-visible)');
    if (!elementos.length) return;

    const sinAnimar = movimientoReducido.matches
      || !('IntersectionObserver' in window)
      || document.documentElement.classList.contains('shopify-design-mode');
    if (sinAnimar) {
      elementos.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('is-visible');
          observador.unobserve(entrada.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    elementos.forEach(function (el) { observador.observe(el); });
  }

  function init(root) {
    if (root.dataset.fyListo) return;
    root.dataset.fyListo = 'true';
    initPestanas(root);
    initGaleria(root);
    initVariantes(root);
    initCarrusel(root);
    initApariciones(root);
  }

  function initTodo(contenedor) {
    contenedor.querySelectorAll('.fy-seccion').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }

  // Editor de temas: secciones recargadas y bloques seleccionados
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    const pestana = e.target.closest && e.target.closest('[role="tab"]');
    if (pestana) pestana.click();
    const tarjeta = e.target.closest && e.target.closest('.fy-carrusel__item');
    if (tarjeta) tarjeta.scrollIntoView({ block: 'nearest', inline: 'start' });
  });
})();
